export const GALLERY = [
  {
    image:
      "https://images.unsplash.com/photo-1758724803399-bab6108b596b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxib2F0JTIwZGV0YWlsaW5nJTIwcG9saXNoaW5nJTIwaHVsbCUyMGNsb3NldXB8ZW58MHx8fHwxNzg2NTY2NTU0fDA&ixlib=rb-4.1.0&q=85",
    label: "Gelcoat restoration",
  },
  {
    image:
      "https://images.unsplash.com/photo-1729475003631-118f0aee787d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxib2F0JTIwZGV0YWlsaW5nJTIwcG9saXNoaW5nJTIwaHVsbCUyMGNsb3NldXB8ZW58MHx8fHwxNzg2NTY2NTU0fDA&ixlib=rb-4.1.0&q=85",
    label: "Hull cut & polish",
  },
  {
    image:
      "https://images.unsplash.com/photo-1741538985627-598bd37b8bae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxib2F0JTIwZGV0YWlsaW5nJTIwcG9saXNoaW5nJTIwaHVsbCUyMGNsb3NldXB8ZW58MHx8fHwxNzg2NTY2NTU0fDA&ixlib=rb-4.1.0&q=85",
    label: "Topside detail",
  },
];

export const PRICING = [
  {
    id: "rinse",
    name: "The Rinse",
    tagline: "Everyday upkeep",
    price: "from $12",
    rate: 12,
    unit: "/ ft",
    example: "≈ $290+ for a 24′ boat",
    features: ["Decontamination hand wash", "Premium wax / polymer sealant", "Deck, rails, glass & chrome", "Ideal between full details"],
    popular: false,
  },
  {
    id: "detail",
    name: "The Detail",
    tagline: "Most requested",
    price: "from $22",
    rate: 22,
    unit: "/ ft",
    example: "≈ $530+ for a 24′ boat",
    features: ["Everything in The Rinse", "Interior deep clean & vinyl conditioning", "Hull scrub & waterline", "Metal polish & brightwork"],
    popular: true,
  },
  {
    id: "signature",
    name: "The Signature",
    tagline: "Showroom finish",
    price: "from $45",
    rate: 45,
    unit: "/ ft",
    example: "≈ $1,080+ for a 24′ boat",
    features: ["Everything in The Detail", "Multi-stage cut & paint correction", "Ceramic / marine coating", "12–24 month protection"],
    popular: false,
  },
];

// Boat style multipliers — bigger/complex boats and rough condition cost more.
export const STYLE_FACTORS = [
  { id: "runabout", label: "Runabout / bowrider", factor: 1.0 },
  { id: "pontoon", label: "Pontoon / tritoon", factor: 1.1 },
  { id: "wake", label: "Wake / ski boat (tower)", factor: 1.2 },
  { id: "cruiser", label: "Cruiser / cabin", factor: 1.28 },
  { id: "neglected", label: "Heavily oxidized / neglected", factor: 1.45 },
];

// Optional paid add-ons (flat price range, added on top of the package).
export const ADDONS = [
  { id: "engine", label: "Engine bay cleaning", low: 75, high: 150 },
  { id: "trailer", label: "Trailer detail", low: 90, high: 180 },
  { id: "canvas", label: "Canvas & clears treatment", low: 60, high: 140 },
  { id: "fabric", label: "Fabric / carpet shampoo", low: 80, high: 160 },
  { id: "ceramic", label: "Ceramic upgrade (+1 yr)", low: 150, high: 400 },
];

export const MEMBERSHIP = {
  name: "The Collective",
  kicker: "Coming Soon",
  desc:
    "Not a membership. A mark of ownership. A private community for those who take pride in what they own — boats first, then cars and everything worth protecting. It begins with the Founding Fleet: the original hundred, #001–#100.",
  perks: ["Founding Fleet #001–#100", "Private gatherings & the Rendezvous", "Priority Black Anchor services", "Exclusive releases"],
};

export const TESTIMONIALS = [
  {
    quote:
      "They treated my boat like it was theirs. The hull hasn't looked this clean since the day I bought it — and it's noticeably faster on the water.",
    name: "Marcus D.",
    detail: "24' Powerboat · Utah Lake",
  },
  {
    quote:
      "Booked online, got a text back same day, and the interior came out spotless. Fair price, zero hassle. Exactly what I wanted.",
    name: "Jenna R.",
    detail: "Pontoon · Jordanelle Reservoir",
  },
  {
    quote:
      "The Signature detail is worth every penny. Ceramic finish still beads months later. These guys are the real deal.",
    name: "Tyler & Sam",
    detail: "32' Cruiser · Bear Lake",
  },
];

export const SERVICE_AREAS = [
  "Utah Lake",
  "Jordanelle Reservoir",
  "Deer Creek Reservoir",
  "Bear Lake",
  "Pineview Reservoir",
  "Great Salt Lake Marina",
  "Rockport & Echo",
  "Private docks & driveways",
];

export const MAP_EMBED =
  "https://www.google.com/maps?q=Salt+Lake+City+Utah&z=8&output=embed";
